import script from "./ImageWidget.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./ImageWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageWidget.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./ImageWidget.vue?vue&type=script&setup=true&lang=ts"

const cssModules = {}
import style0 from "./ImageWidget.vue.scss?vue&type=style&index=0&id=4f2c9831&module=true&lang=scss!=!../../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./ImageWidget.vue?vue&type=style&index=0&id=4f2c9831&module=true&lang=scss"
cssModules["$style"] = style0

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__